import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { MprcRibbonGenericCard } from "components/MprcRibbonList";
import { useTranslation } from "react-i18next";

export const GeneralCardLoading = () => {
    const { t } = useTranslation("core");
    return <MprcRibbonGenericCard
        height={249}
        icon={faSpinner}
        message={t("Card.LoadingText")}
        marginWidth={0}
    />
};
